(function () {
  'use strict';

  angular
    .module('individualCrewScheduleReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('individualCrewScheduleReport', {
    	  sticky: true,
          url: '/individual-crew-schedule-report',
          views: {
              'individualCrewScheduleReportView': {
            	  templateUrl: 'individual-crew-schedule-report/views/individual-crew-schedule-report.tpl.html',
            	  controller: 'IndividualCrewScheduleReportCtrl',
            	  controllerAs: 'individualCrewScheduleReport'
              }
          }
    	  
      });
  }
}());
